<template>
  <c-page>
    <c-navbar></c-navbar>
    <c-tab :tab-items="tabItems"
           @itemClick="itemClickHandler"></c-tab>
    <div class="main" :class="[isAndroid ? 'main-android': '']">
      <keep-alive>
        <components :is="currentView"></components>
      </keep-alive>
    </div>
  </c-page>
</template>
<style lang="scss" scoped>
@import '../../assets/scss/base/__mixin';
.main {
  height:calc(100vh - 1.33333rem);
}

.main-android {
  height:calc(100vh - 2.5rem);
}
.agent-box{
  width:px2rem(750px);
  height:100vh;
  position:fixed;
  background: rgba(0, 0, 0, 0.5);
  overflow-y:hidden;
  z-index:1000000;
  img{
    width:px2rem(600px);
    height:px2rem(750px);
    position:absolute;
    left:0;
    right:0;
    margin:auto;
    top:0;
    bottom:0;
  }
}
</style>
<script>
import IndustryVersion from '@/views/tabs/industry-version'
import ElevenNew from '@/views/tabs/2021-11-11'
import Senior from '@/views/tabs/senior'
import ValueAddedService from '@/views/tabs/value-added-service'
import HardwareMarket from '@/views/tabs/hardware-market'
// import NewEleven from '@/views/tabs/2020-11-11'
// import Rewewal from '@/model/newrenew/index'
// import MiniProgram from '@/views/tabs/2020-05-18/index'
// import PreSale201711 from '@/views/tabs/2019-11-11/pre-sale'
// import RealSale20191111 from '@/views/tabs/2019-11-11/real-sale'
// import Christmas from '@/views/tabs/2019-12-25/index'
// import AllVersion from '@/views/tabs/all-version'
// import Adview from '@/views/tabs/adview'
import RemoteLog from '@/tools/remote-log'
import { mapGetters } from 'vuex'
// import Cookies from 'js-cookie'
// import { mainWeb, mainWebPostData, mainWebResource } from '@/config/net'
// import wejs from 'weui.js'
import Moment from 'moment'
import device from '@/tools/device'
import IOSAvoidReview from '@/mixins/ios-avoid-review'
export default {
  components: {
    // NewEleven,
    IndustryVersion,
    Senior,
    ValueAddedService,
    HardwareMarket,
    ElevenNew
  },
  mixins: [IOSAvoidReview],
  data () {
    let tabNames = ['industry-version', 'value-added-service', 'hardware-market', 'senior', 'eleven-new']
    let tabItems = [

      {
        name: '营销工具',
        select: false,
        component: tabNames[1],
        metaPath: '#/mainview/tab/value-added-service'
      }
      // ,{
      //   name: '硬件超市',
      //   select: false,
      //   component: tabNames[2],
      //   metaPath: '#/mainview/tab/hardware-market'
      // }
    ]
    return {
      tabNames: tabNames,
      currentView: tabItems[0].component,
      tabItems,
      isAndroid: false
    }
  },
  created () {
    this.isAndroid = !device.ios
    // 监听原高级版购买行为
    this.$bus.$on('changeToFullVersionTab', () => {
      this.itemClickHandler(this.tabItems[0])
    })
    this.$bus.$on('openTab', (tabName) => {
      if (!tabName) tabName = this.defaultView
      this.tabItems.forEach((item) => {
        if (item.component === tabName) this.itemClickHandler(item)
      })
    })
    // // 监听跳转到硬件超市行为
    // this.$bus.$on('changeToHardwareMarket', () => {
    //   this.itemClickHandler(this.tabItems[2])
    // })
  },
  async mounted () {
    // 为IOS审核提供（隐藏部分增值业务）
    let isAvoid = await this.$_IOSAvoidReviewMixins_isAvoidReview()
    if (!isAvoid) {
      this.tabItems.unshift(
        {
          name: '行业版本',
          select: false,
          component: this.tabNames[0],
          metaPath: '#/mainview/tab/industry-version'
        })
      this.itemClickHandler(this.tabItems[0])
    } else {
      this.itemClickHandler(this.tabItems[0])
    }
  },
  methods: {
    goBack () {
      const nowPath = this.$route.path
      const haveRedirect = location.search.length !== 0
      if (nowPath === '/' || haveRedirect || nowPath === '/dealer') {
        window.$fe_bridge.navigation.popViewController() // eslint-disable-line
        return
      }
      this.$router.back()
    },
    _getTime (timeStr) {
      return Moment(timeStr, 'yyyy-MM-DD HH:mm:ss').toDate().getTime()
    },
    /**
     * tab 点击事件
     */
    itemClickHandler (itemObj) {
      this.currentView = itemObj.component
      RemoteLog.userVisitPath(itemObj.metaPath)
      for (let item of this.tabItems) {
        item.select = item === itemObj
      }
    }
  },
  computed: {
    ...mapGetters({
      userInfo: 'userInfo/getUserInfo'
    })
  }
}
</script>



// WEBPACK FOOTER //
// index.vue?4b871bce